import React from 'react';
import ThemeToggle from './ThemeToggle';
import MyLadsLogo from './MyLadsLogo';
import { PopupButton } from '@typeform/embed-react';

const Header = () => {
    return (
        <header className="container mx-auto flex justify-between items-center p-4 pb-2 lg:p-6 lg:pb-2 1xl:p-10 1xl:pb-2 bg-site-background fixed left-0 right-0 z-50">
            <MyLadsLogo />
            <div className="flex justify-between items-center space-x-4 md:space-x-8">
                <ThemeToggle />
                <PopupButton
                    id="PjrDUz5k"
                    size={65}
                    className="btn-gradient w-32 md:w-36"
                >
                    Let's Talk
                </PopupButton>
            </div>
        </header>
    );
};

export default Header;
